import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StarIcon from '@mui/icons-material/Star';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
export function Pricing() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(86391);
  const [selected, setSelected] = useState<'pro' | 'standard'>('pro');
  return <section id="pricing" className="py-10 md:py-14 px-4 md:px-6 bg-brand-choco-deep text-white" data-id="element-201">
      <div className="max-w-3xl mx-auto" data-id="element-202">
        {/* Urgency heading */}
        <div className="text-center mb-6 md:mb-8" data-id="element-203">
          <div className="inline-block bg-brand-burgundy text-white px-4 py-2 md:px-5 md:py-2.5 rounded-full font-bold mb-4 md:mb-5 shadow-md animate-pulse text-xs md:text-base" data-id="element-204">
            ⏰ CIERRA EN: {hours} hs : {minutes} min : {seconds} seg
          </div>
          <p className="text-brand-gold font-medium text-xs md:text-base" data-id="element-205">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>
          <p className="text-brand-cream/80 mt-1 font-medium text-xs md:text-base" data-id="element-206">
            🔴 Quedan pocos cupos. 68% ya tomados.
          </p>
          <h2 className="text-2xl md:text-5xl font-serif font-bold mt-4 md:mt-6 tracking-tight" data-id="element-207">
            ELEGÍ TU <span className="text-brand-gold" data-id="element-208">MEGAPACK</span>
          </h2>
        </div>

        {/* Pricing cards stacked */}
        <div className="space-y-3 md:space-y-4" data-id="element-209">
          {/* Card 1 — Standard */}
          <motion.button type="button" onClick={() => setSelected('standard')} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className={`w-full text-left bg-brand-choco rounded-xl md:rounded-2xl border-2 transition-all p-3.5 md:p-6 flex items-center gap-3 md:gap-6 ${selected === 'standard' ? 'border-brand-gold shadow-lg shadow-brand-gold/10' : 'border-white/10 hover:border-white/20'}`} data-id="element-210">
            {/* Radio */}
            <span className={`flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'standard' ? 'border-brand-gold' : 'border-white/40'}`} data-id="element-211">
              {selected === 'standard' && <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-gold" data-id="element-212" />}
            </span>

            {/* Info */}
            <div className="flex-1 min-w-0" data-id="element-213">
              <MenuBookIcon className="text-brand-gold mb-0.5 md:mb-1" style={{
              fontSize: 20
            }} data-id="element-214" />
              <h3 className="text-sm md:text-xl font-bold leading-tight" data-id="element-215">
                MEGAPACK
                <br className="md:hidden" data-id="element-216" /> VELAS QUE SE COMEN
              </h3>
              <p className="text-[11px] md:text-sm text-white/60 mt-0.5 md:mt-1" data-id="element-217">
                Tomo 1 + Tomo 2 + 4 Bonos
              </p>
              <p className="text-[11px] md:text-sm text-brand-gold font-semibold mt-1 md:mt-1.5 leading-snug" data-id="element-218">
                Ideal para: Hobby, regalos y emprender desde casa
              </p>
            </div>

            {/* Price */}
            <div className="flex-shrink-0 text-right" data-id="element-219">
              <div className="line-through text-white/40 text-xs md:text-base" data-id="element-220">
                $51.000
              </div>
              <div className="text-base md:text-3xl font-bold text-white whitespace-nowrap" data-id="element-221">
                $19.990{' '}
                <span className="text-xs md:text-base font-medium text-white/70" data-id="element-222">
                  ARS
                </span>
              </div>
            </div>
          </motion.button>

          {/* Card 2 — Pro (Featured) */}
          <motion.button type="button" onClick={() => setSelected('pro')} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className={`w-full text-left bg-brand-choco rounded-xl md:rounded-2xl border-2 transition-all p-3.5 md:p-6 flex items-center gap-3 md:gap-6 relative ${selected === 'pro' ? 'border-brand-gold shadow-lg shadow-brand-gold/20' : 'border-white/10 hover:border-white/20'}`} data-id="element-223">
            <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-choco-deep font-bold px-2.5 py-0.5 rounded-full text-[9px] md:text-xs uppercase tracking-wider whitespace-nowrap" data-id="element-224">
              ⭐ Más elegido
            </span>

            {/* Radio */}
            <span className={`flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-brand-gold' : 'border-white/40'}`} data-id="element-225">
              {selected === 'pro' && <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-gold" data-id="element-226" />}
            </span>

            {/* Info */}
            <div className="flex-1 min-w-0" data-id="element-227">
              <EmojiEventsIcon className="text-brand-gold mb-0.5 md:mb-1" style={{
              fontSize: 22
            }} data-id="element-228" />
              <h3 className="text-sm md:text-xl font-bold leading-tight" data-id="element-229">
                MEGAPACK + <br className="md:hidden" data-id="element-230" />
                EMBAJADORA
                <StarIcon className="text-brand-gold ml-1 -mt-1" style={{
                fontSize: 14
              }} data-id="element-231" />
              </h3>
              <p className="text-[11px] md:text-sm text-white/60 mt-0.5 md:mt-1" data-id="element-232">
                Tomos + 4 Bonos + Kit de Negocio
              </p>
              <p className="text-[11px] md:text-sm text-brand-gold font-semibold mt-1 md:mt-1.5 leading-snug" data-id="element-233">
                Ideal para: Catering, eventos y facturar en grande
              </p>
            </div>

            {/* Price */}
            <div className="flex-shrink-0 text-right" data-id="element-234">
              <div className="line-through text-white/40 text-xs md:text-base" data-id="element-235">
                $69.000
              </div>
              <div className="text-base md:text-3xl font-bold text-brand-gold whitespace-nowrap" data-id="element-236">
                $29.990
              </div>
            </div>
          </motion.button>
        </div>

        {/* Bottom CTA */}
        <a href={selected === 'pro' ? 'https://pagos.indigo33.shop/cart/63639160717681:1' : 'https://pagos.indigo33.shop/cart/63639147512177:1'} target="_blank" rel="noopener noreferrer" className="mt-5 md:mt-6 block w-full text-center bg-brand-gold hover:bg-brand-amber text-brand-choco-deep font-bold py-3.5 md:py-5 px-4 rounded-xl transition-colors shadow-lg shadow-brand-gold/20 text-xs md:text-lg uppercase tracking-wide" data-id="element-237">
          <ArrowForwardIcon className="mr-1.5 md:mr-2 -mt-0.5" style={{
          fontSize: 18
        }} data-id="element-238" />
          {selected === 'pro' ? 'QUIERO EL MEGAPACK + EMBAJADORA' : 'QUIERO MI MEGAPACK'}
        </a>

        <p className="text-center text-[10px] md:text-sm text-white/50 mt-3 md:mt-4" data-id="element-239">
          🔒 Pago 100% seguro · ⚡ Acceso en 5 min · 🛡️ Garantía 7 días
        </p>
      </div>
    </section>;
}